var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3326 21.3312C24.4366 20.4992 23.8766 19.3152 23.8766 17.9992C23.8766 16.6832 24.4366 15.4992 25.3326 14.6672C25.5726 14.4432 25.8406 14.2432 26.1246 14.0792C27.0206 13.2472 27.5806 12.0632 27.5806 10.7472C27.5806 8.23522 25.5406 6.19922 23.0286 6.19922C20.5166 6.19922 18.4766 8.23522 18.4766 10.7472C18.4766 12.0632 19.0366 13.2472 19.9326 14.0792C20.2166 14.2472 20.4846 14.4432 20.7246 14.6672C21.6206 15.4952 22.1806 16.6832 22.1806 17.9992C22.1806 19.3152 21.6206 20.5032 20.7246 21.3312C20.4846 21.5552 20.2166 21.7512 19.9326 21.9192C19.0366 22.7512 18.4766 23.9352 18.4766 25.2512C18.4766 27.7632 20.5126 29.7952 23.0286 29.7952C25.5446 29.7952 27.5806 27.7592 27.5806 25.2512C27.5806 23.9352 27.0206 22.7472 26.1246 21.9192C25.8366 21.7512 25.5726 21.5552 25.3326 21.3312Z",
    fill: "#004BEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5919 14.6797C13.3439 14.6797 14.7639 16.0997 14.7639 17.8477C14.7639 19.5957 13.3439 21.0157 11.5919 21.0157C9.83992 21.0157 8.41992 19.5957 8.41992 17.8477C8.41992 16.0997 9.83992 14.6797 11.5919 14.6797Z",
    fill: "#004BEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0278 10.416L11.5918 17.852L23.0278 25.58",
    stroke: "#004BEE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipOperations);
export default __webpack_public_path__ + "static/media/HIP Operations.3a21dee46e3ac149cb26e8745118b509.svg";
export { ForwardRef as ReactComponent };